// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --offset: 180;
  --strokeDrawDuration: 1.8s;
  --spinDuration: calc(-.2s + var(--strokeDrawDuration));
}

@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 180;
  }
  50% {
    stroke-dashoffset: 55;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 180;
    transform: rotate(360deg);
  }
}

.loader {
  display: flex;
  gap: calc(.5rem);
  align-items: baseline;
  justify-content: center;
}

.loader--determinate .loader__spinner {
      animation: none;
    }

.loader--determinate .loader__path {
      animation: none;
    }

.loader--inline {
    display: inline-flex;
  }

.loader--inline--with-spacer {
      margin: 0 1rem;
    }

.loader--full-page {
    flex-direction: column;
    gap: calc(2rem);
    align-items: center;
    height: 100%;
    min-height: 60vh;
  }

.loader--full-page .loader__spinner {
      height: calc(2rem);
    }

.loader--full-page .loader__text {
      font-weight: 700;
    }

.loader--small {
    flex-direction: column;
    align-items: center;
  }

.loader--small .loader__spinner {
      height: calc(1.5rem);
    }

.loader--large {
    flex-direction: column;
    align-items: center;
  }

.loader--large .loader__spinner {
      height: calc(2rem);
    }

.loader__spinner {
    display: flex;
    align-self: center;
    height: 1rem;
    animation: rotator calc(1.6s) linear infinite;
  }

.loader__background {
    stroke: #f6f7f8;
  }

.loader__path {
    stroke-dasharray: 180;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: dash 1.8s ease-in-out infinite;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
